import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import useApi from "../../../core/customhook/useApi";
import Loader from "../../../core/common/selfLoder";
import LeaveChart from "./LeaveChart";
import LeavePieChart from "./LeavePieChart";
import { getFinancialYearList } from "../../../core/common/financialYear";

const SelfLeaveDashboard = () => {

    const formatFinancialYear = (year: number) => {
        const nextYearShort = (year + 1).toString().slice(-2);
        return `${year}-${nextYearShort}`;
    };

    const getFinancialYear = () => {
        const today = new Date();
        const year = today.getFullYear(); // Jan–Dec same year
        return formatFinancialYear(year);
    };

    const [finance_year, setFinance_year] = useState(getFinancialYear());


    const {
        data: leave_Balance_data,
        loading: leave_balance_loading,
        error: leave_balance_error,
    } = useApi("/api/view-leave-balance-dashboard", {
        method: "POST",
        payload: {
            financial_year: finance_year,
        },
        autoCall: true,
        dependencies: [finance_year],
    });


    useEffect(() => {
        console.log(finance_year, "finance_year");
        console.log(leave_Balance_data?.data, "leave_Balance_data");
    }, [])

    return (
        <>
            <Loader loading={leave_balance_loading} />
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-2">
                        <div className="my-auto mb-2">
                            <h2 className="mb-2">Leave Dashboard</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.employeeDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Work & Operations</li>
                                    <li className="breadcrumb-item">Leave</li>
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.seflGrid}>Self Leave</Link>
                                    </li>

                                    <li className="breadcrumb-item active" aria-current="page">
                                        Leave Dashboard
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                            <div className="me-2 mb-2"></div>
                            <div className="input-icon w-120 position-relative mb-2">
                                <span className="input-icon-addon">
                                    <i className="ti ti-calendar text-gray-9" />
                                </span>

                                <select
                                    value={finance_year}
                                    onChange={(e) => setFinance_year(e.target.value)}
                                    className="form-select"
                                >
                                    {getFinancialYearList().map((fy) => (
                                        <option key={fy} value={fy}>
                                            {fy.split("-")[0]}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="head-icons ms-2">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>

                    {/* <div className="row">
                        <div className="col-12 col-md-4 d-flex justify-content-center  mt-2">
                            <LeaveChart title="SL" balance={4} availed={8} total={12} />
                        </div>
                        <div className="col-12 col-md-4 d-flex justify-content-center mt-2">
                            <LeaveChart title="EL" balance={6.5} availed={5.5} total={12} />
                        </div>
                        <div className="col-12 col-md-4 d-flex justify-content-center mt-2">
                            <LeaveChart title="RH" balance={2} availed={18} total={20} />
                        </div>
                    </div> */}

                    {!leave_balance_loading && <div className="row">
                        {["Sick Leave", "Earned Leave", "Restricted Holiday"].map((type) => {
                            const leave = leave_Balance_data?.data?.find(
                                (item: any) => item.leave_type === type
                            );

                            const shortTitleMap: Record<string, string> = {
                                "Sick Leave": "SL",
                                "Earned Leave": "EL",
                                "Restricted Holiday": "RH",
                            };

                            return (
                                <div
                                    key={type}
                                    className="col-12 col-md-4 d-flex justify-content-center mt-2"
                                >
                                    <LeaveChart
                                        title={shortTitleMap[type]}
                                        balance={leave?.closing_balance || 0}
                                        availed={leave?.availed_balance || 0}
                                        // total={leave?.opening_balance || 0}
                                        total={(
                                            (parseFloat(
                                                leave?.opening_balance
                                            ) || 0) +
                                            (parseFloat(
                                                leave?.prorata_balance
                                            ) || 0)
                                        ).toFixed(2)}
                                    />
                                </div>
                            );
                        })}
                    </div>
                    }


                    <div className="row">
                        <div className="col-12 mt-2">
                            <LeavePieChart financial_year={finance_year} />
                        </div>

                    </div>

                </div>
                <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
                    <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
                </div>
            </div>


        </>
    );
};

export default SelfLeaveDashboard;
